import type { AttributeOption, ReportFormState } from 'types/tpo/reportSetup';

export const sectionColumnsClass: Record<number, string> = {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
};

export const PAGE_LIMIT = 50;

export const isValueFilled = (val: any) => {
    if (val === null || val === undefined) return false;
    if (typeof val === 'string') return val.trim() !== '';
    if (Array.isArray(val)) return val.length > 0;
    return true;
};

export const REPORT_DETAILS_TO_FORM_KEY_MAP: Record<string, string> = {
    name: 'report_name',
    customer_hierarchy: 'customer_hierarchy',
    product_hierarchy: 'product_hierarchy',
    promotion_granularity: 'promotion_granularity',
    is_plan_level: 'enable_plan_level_data',
};

export const buildFormStateFromReport = (reportDetails: any, firstTabKey: string): ReportFormState => {
    const reportType = reportDetails?.report_type ?? firstTabKey;
    const tabValues: Record<string, any> = {};
    const presetMap: Record<string, AttributeOption[]> = {};

    for (const [reportKey, formKey] of Object.entries(REPORT_DETAILS_TO_FORM_KEY_MAP)) {
        if (reportDetails?.[reportKey] != null) tabValues[formKey] = reportDetails[reportKey];
    }

    const filters = reportDetails?.filters ?? {};
    const allItems = Object.values(filters).flatMap((entry: any) => [
        ...(Array.isArray(entry?.inclusion) ? entry.inclusion : []),
        ...(Array.isArray(entry?.exclusion) ? entry.exclusion : []),
    ]);
    for (const item of allItems) {
        const fieldKey = item?.attributeType;
        if (!fieldKey) continue;
        // `??=` lazily seeds the per-field array on first encounter, replacing
        // the previous "if (!array) array = []; array.push(...)" pair.
        (tabValues[fieldKey] ??= []).push(item.attributeExId);
        (presetMap[fieldKey] ??= []).push({
            label: item.attributeDesc ?? String(item.attributeExId),
            value: item.attributeExId,
            attributeType: item.attributeType,
            dimension: item.dimension,
            attributeConfigId: item.attributeConfigId,
        });
    }

    return {
        activeTabKey: reportType,
        formValuesByTab: { [reportType]: tabValues },
        presetOptionsByFieldKey: presetMap,
    };
};
